import { Route, Routes } from 'react-router-dom';
// import { Toaster } from 'react-hot-toast';

import Overview from './pages/Overview';
import Result from './pages/Result';
import TermsAndConditions from './pages/TermsAndConditions';
import ForgetPassword from './pages/Authentication/ForgetPassword';
import Verification from './pages/Authentication/Verification';
import ResetPassword from './pages/Authentication/ResetPassword';
import Profile from './pages/profile/Profile';
import { LanguageProvider } from './ChangeLanguage/LanguageContext';
import { useEffect } from 'react';
// import routes from './routes';

function App() {

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return  (
    <div  id="">
       <LanguageProvider>
       <Routes>
        <Route path='/' element={<Overview />} />
        <Route path='/#faq' element={<Overview />} />
        <Route path='/result' element={<Result />} />
        <Route path='/terms-and-condition' element={<TermsAndConditions />} />
        <Route path='/forget-password' element={<ForgetPassword />} />
        <Route path='/verification' element={<Verification />} />
        <Route path='/reset' element={<ResetPassword />} />
        <Route path='/profile' element={<Profile />} />
      </Routes>
    </LanguageProvider>
   
    </div>
  );
}

export default App;
